var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonComponent',_vm._g(_vm._b({attrs:{"label":_vm.$t('copy'),"success-label":_vm.$t('copied'),"icon":['fal', 'copy'],"promise":_vm.clipPromise},on:{"click":_vm.copy}},'ButtonComponent',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }